import { render, staticRenderFns } from "./ModalHandler.vue?vue&type=template&id=17ff37ac&scoped=true"
import script from "./ModalHandler.vue?vue&type=script&lang=js"
export * from "./ModalHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ff37ac",
  null
  
)

export default component.exports